import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import PreprimarySidebar2026 from '../PreprimarySidebar2026';
import Presidebar2026 from '../Presidebar2026/Presidebar2026';


const PictureTalkmont2026= () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalkmont/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalkmont/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalkmont/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/PictureTalkmont/4.webp`;
  

  const photos = [
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
 Topic: Picture Talk
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
   Classes: Montessori – I, II, III      Date: 24 July, 2026
        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
 Picture Talk – Little Voices, Big Ideas
<br></br>
        </Typography> */}


        <Typography variant={'subtitle1'} align={'justify'}>
On 24 July 2026, the Picture Talk Event was conducted in the Montessori section with great enthusiasm. The activity provided children with an opportunity to express their thoughts confidently while developing their communication skills.
 They spoke on a variety of familiar and meaningful topics, including family, celebrations, favourite places, food, friendships,
 vacations, and memorable experiences, showcasing their growing confidence, vocabulary and the ability to communicate their ideas effectively.
      <br></br>
Montessori I children expressed in simple words and short sentences, showing confidence and developing vocabulary. 
Montessori II children described their pictures in complete sentences, displayed creativity and listened attentively to their peers. Montessori III children impressed everyone with detailed descriptions, expressive storytelling and confident public speaking.
 <br></br>

The event provided a wonderful platform for children to enhance their language, creativity and communication skills. 
The enthusiastic participation of the children and the constant support of the parents made the programme a grand success.
<br></br>


        </Typography>
      </Box>

      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
BUILDING CONFIDENCE, ONE CONVERSATION AT A TIME.

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Presidebar2026 />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default PictureTalkmont2026;